import { render, staticRenderFns } from "./CollageDiff.vue?vue&type=template&id=0cae1cd1&scoped=true&"
import script from "./CollageDiff.vue?vue&type=script&lang=js&"
export * from "./CollageDiff.vue?vue&type=script&lang=js&"
import style0 from "./CollageDiff.vue?vue&type=style&index=0&id=0cae1cd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae1cd1",
  null
  
)

export default component.exports